<style scoped lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/interface/sync/log/page" getKey="rows"
			:columns="columns" @expandChange="expandChange">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('jiekoumingcheng')">
						<el-input v-model="yt.conditions.interfaceName"></el-input>
					</el-form-item>
					<el-form-item :label="$t('chuangjianshijian')">
						<yi_time_input type="datetimerange" :start.sync="yt.conditions.startTime"
							:end.sync="yt.conditions.endTime">
						</yi_time_input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain>
							{{ $t('sousuo') }}
						</el-button>
						<el-button @click="clear()">{{ $t('chongzhi') }}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" v-if="utils.checkPower('web_system_interface_sync_log_material')"
					@click="yt.showEditDialog('tongbuwuliaoxinxi', null, 'w1')" type="primary">
					{{ $t("tongbuwuliaoxinxi") }}
				</el-button>
				<el-button size="mini" v-if="utils.checkPower('web_system_interface_sync_log_mould')"
					@click="yt.showEditDialog('tongbumojutaizhang', null, 'w1')" type="primary">
					{{ $t("tongbumojutaizhang") }}
				</el-button>
				<el-button size="mini" v-if="utils.checkPower('web_system_interface_sync_log_orders')"
					@click="yt.showEditDialog('tongbupaigongdan', null, 'w1')" type="primary">
					{{ $t("tongbupaigongdan") }}
				</el-button>
			</template>
			<template #caozuomiaoshu="scope">
				{{ $t(scope.row.i18nKey) }}
			</template>
		</yi_curd_table>
		<!-- 同步信息弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 同步物料信息 -->
			<template v-if="yt.editObj.action == 'tongbuwuliaoxinxi'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('wuliaobianma')" required>
						<el-input type="textarea" show-word-limit :maxlength="2000" :rows="4" style="width: 100px;" placeholder="多个物料编码以,隔开" v-model="yt.editObj.codes">

						</el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST', '/custom/qunlong/material/syncQunlongMaterial')" type="primary">
						{{ $t("tongbu") }}
					</el-button>
				</span>
			</template>
			<!--同步模具台账 -->
			<template v-if="yt.editObj.action == 'tongbumojutaizhang'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('mujubianhao')" required>
						<el-input  type="textarea" show-word-limit :maxlength="2000" :rows="4" style="width: 100px;" placeholder="多个模具编号以,隔开" v-model="yt.editObj.codes">

						</el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST', '/custom/qunlong/mould/syncQunlongMould')" type="primary">
						{{ $t("tongbu") }}
					</el-button>
				</span>
			</template>
			<!--同步派工单 -->
			<template v-if="yt.editObj.action == 'tongbupaigongdan'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('gongdanhangbianma')" required>
						<el-input  type="textarea"  show-word-limit :maxlength="2000" :rows="4"  style="width: 100px;" placeholder="多个工单行编码以,隔开" v-model="yt.editObj.codes">
						</el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST', '/custom/qunlong/work/orders/syncQunlongWorkOrders')" type="primary">
						{{ $t("tongbu") }}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
export default {
	name: 'web_system_interface_sync_log_list',

	data() {
		return {
			list: [],
			columns: [{
				label: 'jiekoumingcheng',
				prop: 'interfaceName',
			},
			{
				label: 'jiekourucan',
				prop: 'interfaceParams',
			},
			{
				label: 'jiekoufanhuixinxi',
				prop: 'interfaceReturnInfo'
			},
			{
				label: 'chuangjianren',
				prop: 'createByObject.nickname'
			},
			{
				label: 'chuangjianshijian',
				prop: 'createTime',
				type: 'time',
			}
			],
		};
	},
	created() {
		setTimeout(() => {
			// table列表接口请求参数
			this.$set(this.yt.conditions, 'startTime', this.begin())
			this.$set(this.yt.conditions, 'endTime', this.end())
			this.yt.get(1);
		}, 300)

	},
	methods: {

		// 重置
		clear() {
			let param = {
				pageSize: 1000,
				startTime: this.begin(),
				endTime: this.end(),
			}
			this.yt.clear(param)

		},

		begin() {
			const date = new Date()
			const begin = (new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)).getTime()
			return begin
		},
		end() {
			const date = new Date()
			const year = date.getFullYear();
			const month = date.getMonth() + 1;
			const lastDay = new Date(year, month, 0).getDate();
			const end = (new Date(year, month - 1, lastDay, 23, 59, 59)).getTime()
			return end
		},
	},
};
</script>
